import React, { useState } from 'react';
import { Alert, Form, Input } from 'antd';
import moment from 'moment';
import BaseModal from '../../../BaseModal/BaseModal';
import DateTimeField from './DateTimeField';
import { checkDateTime, transformValues } from './utils';
import { fieldNames } from './constants';
import { useSetModalVisible } from '../../../../model/modalState';
import { useSubmit } from '../../../../api';
import InformationBlockModal from '../../../InformationBlockModal/InformationBlockModal';
import { typeMassActionsText } from '../../../InformationBlockModal/constants';

const { TextArea } = Input;
const { Item: FormItem, create: createForm } = Form;

const Container = ({ form, requests, onSuccess }) => {
  const { getFieldDecorator, validateFields, resetFields } = form;

  const setModalVisible = useSetModalVisible();
  const [stateInfo, setStateInfo] = useState(false);
  const [value, setValue] = useState(null)

  const { submitAsync, loading } = useSubmit({
    url: 'Request/set_execute_date',
    errMsg: 'Не удалось изменить дату назначения у выбранных заявок',
    onSuccess,
  });

  const handleSubmit = (e) => {
    e.preventDefault();

    validateFields((err, values) => {
      if (!err) {
        const value = transformValues(values);
        setValue(value);
        setStateInfo(true);
      }
    });
  };

  const handleConfirmSubmit = async (e) => {
      e.preventDefault()
  
      try {
        await submitAsync({
          ids: requests.map(({ id }) => id),
          value,
          requests,
        });
  
        setModalVisible(false);
        setStateInfo(false);
        resetFields();
      } catch(error) {
        return <Alert title={error.message} />
      }
    }

  const cancelSubmit = () => {
    setStateInfo(false);
    resetFields()
  }

  return (
    <BaseModal
      onCancel={cancelSubmit}
      title={stateInfo ? "Подтвердите изменения" : "Изменение времени назначения"}
      onOk={stateInfo ? handleConfirmSubmit : handleSubmit}
      width={stateInfo ? 600 : 450}
      confirmLoading={loading}
    >
      {!stateInfo ? (
      <Form>
        <FormItem
          label="Дата и время назначения"
          required
        >
          {getFieldDecorator(fieldNames.executeDateTime, {
            initialValue: { date: moment(), time: moment('18:00', 'HH:mm') },
            rules: [{ validator: checkDateTime }],
          })(<DateTimeField />)}
        </FormItem>

        <FormItem label="Причина переноса даты назначения">
          {getFieldDecorator(fieldNames.note, {
            initialValue: '',
            rules: [
              {
                required: true,
                whitespace: true,
                message: 'Укажите причину переноса',
              },
            ],
          })(<TextArea autoSize={{ minRows: 2, maxRows: 4 }} />)}
        </FormItem>
      </Form>
    ) : (
      <InformationBlockModal typeMassActions={typeMassActionsText.dataTime} count={requests.length} />
    )}
    </BaseModal>
  );
};

const ChangeExecuteDateTime = createForm({
  name: 'mass_actions_execute_date',
})(Container);

export default ChangeExecuteDateTime;
